import { Button, CircularProgress, Drawer, Grid, Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useCategoryStore } from "../../../hooks/useCategoryStore";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { useProductAttributeStore } from "../../../hooks/useProductAttributeStore";
import { useTypeAttributeStore } from "../../../hooks/useTypeAttributeStore";

const columns = [
    { type: 'text', field: 'name', label: 'Marca', align: 'center' },
    { type: 'checkbox', field: 'checkbox', label: '', align: 'center' },  
];

export const DrawerOptimizated: FC<any> = (props): JSX.Element | any => {
    const { open, closeModal } = props;
    const { getReviewData } = useCategoryStore();
    const { optimizatedproductAttribute } = useProductAttributeStore();
    const { gettypeAttributeByCompany} = useTypeAttributeStore();
    const [data, setData] = useState<any[]>([]);
    const [originalData, setOriginalData] = useState<any[]>([]);  // Estado para mantener la data original
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingSaveReference, setLoadingSaveReference] = useState<boolean>(false);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);  // Estado para filas seleccionadas
    const [idTypeSelected, setIdTypeSelected] = useState<number>(0);
    const [allSelected, setAllSelected] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        gettypeAttributeApi();
        getReviewDataAPI();
    }, []);

    const gettypeAttributeApi = async(search='') => {
        try {
            setLoading(true);
            const response = await gettypeAttributeByCompany(search);
            if(!response){
                setLoading(false);
                return false;
            }else{
                const typeFind = response.find(item => item.name == 'MARCA')
                setIdTypeSelected(typeFind?.id);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const getReviewDataAPI = async () => {
        setLoading(true);
        try {
            const response = await getReviewData();
            setData(response);
            setOriginalData(response);  // Guardar la data original
        } catch (error) {
            console.error('Error fetching duplicated categories', error);
        } finally {
            setLoading(false);
        }
    };

    const onSearch = (term: string) => {
        clearTimeout(searchTimeout);
        setSearchTimeout(
            setTimeout(() => {
                if (term) {
                    // Filtrar la data original basada en el término de búsqueda
                    const filteredData = originalData.filter(item => 
                        item.name.toLowerCase().includes(term.toLowerCase())
                    );
                    setData(filteredData);
                } else {
                    // Restaurar la data original si no hay término de búsqueda
                    setData(originalData);
                }
            }, 500)  // Añadir un pequeño debounce
        );
    }

    const addReference = async() => {
        console.log('Filas seleccionadas para unificar:', selectedRows);
        const payload = {
            data: selectedRows,
            idtype: idTypeSelected
        }
        await optimizatedproductAttribute(payload);
        closeModal();
    };

    const onCheckbox = (row: any) => {
        const selectedIndex = selectedRows.findIndex(selectedRow => selectedRow.name === row.name);
        let newSelected:any = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, row);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1)
            );
        }
        setSelectedRows(newSelected);
        setAllSelected(newSelected.length === data.length);

    };

    const selectAllRows = () => {
        if (allSelected) {
            setSelectedRows([]);
            setAllSelected(false);
        } else {
           setSelectedRows(data);
            setAllSelected(true);
        }
    };

    const isSelected = (row: any) => selectedRows.some(selectedRow => selectedRow.name === row.name);


    return (
        <>
            <Drawer anchor="right" open={open} onClose={closeModal} ModalProps={{ keepMounted: true }} PaperProps={{ sx: { width: 550 } }}>
                <Grid container spacing={2} padding={4}>
                    <Grid item xs={12}>
                        <Typography variant='h6' component='h1' className='title-main'>Marcas encontradas</Typography>
                    </Grid>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'right' }}>
                        <Button
                            sx={{
                                backgroundColor: '#ffffff',
                                border: '1px solid #69ABC3',
                                borderRadius: '10px',
                                color: '#69ABC3',
                                height: '25px',
                                padding: '6px 16px',
                                textTransform: 'none',
                                width: 180,
                                "&:hover": { backgroundColor: "#ffffff" }
                            }}
                            onClick={addReference}
                        >
                            optimizar registros
                            {loadingSaveReference && (
                                <CircularProgress color="inherit" size={12} sx={{ color: '#5b5b5b', marginLeft: "10px" }} />
                            )}
                        </Button>
                    </Grid>

                    <Grid item xs={12}>
                        <CustomTable
                            disabled_title
                            columns={columns}
                            loading={loading}
                            rows={data}
                            onRowClick={() => { }} 
                            isSelected={isSelected} 
                            onCheckbox={onCheckbox} 
                            selectAll={selectAllRows}
                            allSelected={allSelected}
                            onSearch={onSearch}
                            hasOptions={false}
                            dense
                        />
                    </Grid>
                </Grid>
            </Drawer>
        </>
    );
};
